<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <div class="filter-wrapper">
                    <p class="title">Manage Filters:</p>
                    <div class="filter-container">
                        <div class="filter-item">
                            <date-range-picker :label="created_at_label" control-container-class="nice-select" opens="right" @select="getRange" @clear="clearRange"></date-range-picker>
                        </div>
                        <div class="filter-item">
                            <select class="nice-select" v-model="filters.product_type" 
                                @change="
                                    filters.product_model = 'all';
                                    filters.item = 'all';
                                    filters.problem_type = 'all';
                                    get_items();
                                    filter_list();
                                ">
                                <option value="all">Prod. Category: All</option>
                                <option v-for="(type, key) in procedures" :value="key" :key="key">{{ key }}</option>
                                <option value="Others">Others</option>
                            </select>
                        </div>
                        <div class="filter-item">
                            <select class="nice-select" v-model="filters.product_model" 
                                @change="
                                    filters.item = 'all';
                                    filters.problem_type = 'all';
                                    get_items();
                                    get_problem_types();
                                    filter_list();
                                ">
                                <option value="all">Prod. Model: All</option>
                                <template v-if="procedures[filters.product_type] && filters.product_type == 'Machines'">
                                    <option v-for="(model, key) in procedures[filters.product_type]" :value="key" :key="key">{{ key }}</option>
                                    <option value="Others">Others</option>
                                </template>
                            </select>
                        </div>
                        <div class="filter-item">
                            <select class="nice-select" v-model="filters.item" 
                                @change="
                                    filters.problem_type = 'all';
                                    get_problem_types();
                                    filter_list();
                                ">
                                <option value="all">Item: All</option>
                                <option v-for="(item, key) in items" :value="item.item" :key="key">{{ item.item }}</option>
                            </select>
                        </div>
                        <div class="filter-item">
                            <select class="nice-select" v-model="filters.problem_type" @change="filter_list">
                                <option value="all">Problem Type: All</option>
                                <template v-if="problem_types && filters.product_model != 'all'">
                                    <option v-for="(problem, key) in problem_types" :value="problem.title" :key="key">{{ problem.title }}</option>
                                    <option value="Others">Others</option>
                                </template>
                            </select>
                        </div>
                        <div class="filter-item">
                            <select class="nice-select" v-model="filters.status" @change="filter_list">
                                <option value="all">Status: All</option>
                                <option value="UNAPPROVED">UNAPPROVED</option>
                                <option value="OPEN">OPEN</option>
                                <option value="PENDING">PENDING</option>
                                <option value="CLOSED">CLOSED</option>
                            </select>
                        </div>
                        <div class="filter-item search-filter">
                            <input type="text" placeholder="Search" v-model="filters.search" @change="filter_list">
                            <button type="button" @click="filter_list"><i class="fa fa-search"></i></button>
                        </div>
                        <div class="filter-reset-btn">
                            <a href="javascript:void(0)" title="Refresh" @click="reset_filter">
                                <i class="fa fa-refresh reset-icon" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="table-responsive">
                    <div id="ses-list" class="list-proj" @scroll="scroll_list">
                        <div class="row list-head">
                            <div class="col" data-key="ticket_no" @click="sort_list">Ticket #</div>
                            <div class="col" data-key="product_type" @click="sort_list">Product Category</div>
                            <div class="col" data-key="product_model" @click="sort_list">Product Model</div>
                            <div class="col" data-key="item" @click="sort_list">Item</div>
                            <div class="col" data-key="problem_type" @click="sort_list">Problem Type</div>
                            <div class="col" data-key="city_state" @click="sort_list">City and State</div>
                            <div class="col" data-key="job_name" @click="sort_list">Job Name</div>
                            <div class="col" data-key="car_no" @click="sort_list">Car #</div>
                        </div>
                        <div class="list-row" v-for="row in service_tickets" :key="row.id">
                            <div class="row list-data">
                                <div class="col">{{ row.ticket_no }}</div>
                                <div class="col">{{ row.product_type }}</div>
                                <div class="col">{{ row.product_model }}</div>
                                <div class="col">{{ row.item }}</div>
                                <div class="col">{{ row.problem_type }}</div>
                                <div class="col">{{ row.city_state }}</div>
                                <div class="col">{{ row.job_name }}</div>
                                <div class="col">{{ row.car_no }}</div>
                            </div>
                            <div class="row list-action">
                                <div class="col-md-12 action-wrap">
                                    <badge class="badge-dot mr-4" :type="row.status.toLowerCase()">
                                        <span class="status">{{ row.status.toLowerCase() }}</span>
                                    </badge>
                                    <div class="action-links">
                                        <a v-if="row.job_link" :href="row.job_link" target="_blank">Field Report</a>
                                        <a v-if="row.service_call_id && row.status == 'CLOSED'" :href="'/api/service_call_report/' + row.service_call_id" target="_blank">Service Call Report</a>
                                        <a href="javascript:void(0);" @click="get_service_ticket(row.id)">View</a>
                                        <a href="javascript:void(0);" @click="remove_service_ticket(row.id)">Remove</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <template v-if="service_tickets.length == 0 && !isListLoading">
                        <p class="no-results-msg">No results found</p>
                    </template>
                    <template v-if="isListLoading">
                        <div class="progress">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <modal :show="showViewModal" @close="showViewModal = false">
            <template slot="header"><h3>Service Ticket</h3></template>
            <template>
                <div class="row">
                    <div class="col-md-6">
                        <div class="row-detail">
                            <label>Ticket No.:</label>
                            <div>{{ model.ticket_no }}</div>
                        </div>
                        <div class="row-detail">
                            <label>Product Category:</label>
                            <div>{{ model.product_type }}</div>
                        </div>
                        <div class="row-detail">
                            <label>Product Model:</label>
                            <div>{{ model.product_model }}</div>
                        </div>
                        <div class="row-detail">
                            <label>Item:</label>
                            <div>{{ model.item }}</div>
                        </div>
                        <div class="row-detail">
                            <label>Problem Type:</label>
                            <div>{{ model.problem_type }}</div>
                        </div>
                        <div class="row-detail">
                            <label>Serial Number:</label>
                            <div>{{ model.serial_no }}</div>
                        </div>
                        <div class="row-detail">
                            <label>Last Maintenance Date:</label>
                            <div>{{ model.last_maintenance_date }}</div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="row-detail">
                            <label>Customer Name:</label>
                            <div>{{ model.customer_name }}</div>
                        </div>
                        <div class="row-detail">
                            <label>Mechanic Name:</label>
                            <div>{{ model.mechanic_name }}</div>
                        </div>
                        <div class="row-detail">
                            <label>Cell Phone #:</label>
                            <div>{{ model.cellphone }}</div>
                        </div>
                        <div class="row-detail">
                            <label>Email:</label>
                            <div>{{ model.email }}</div>
                        </div>
                        <div class="row-detail">
                            <label>Job Name:</label>
                            <div>{{ model.job_name }}</div>
                        </div>
                        <div class="row-detail">
                            <label>Car #:</label>
                            <div>{{ model.car_no }}</div>
                        </div>
                        <div class="row-detail">
                            <label>City and State:</label>
                            <div>{{ model.city_state }}</div>
                        </div>
                        <div class="row-detail">
                            <label>Status:</label>
                            <div>{{ model.status }}</div>
                        </div>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-md-12">
                        <div class="row-detail">
                            <label style="min-width: 50px;">Issue:</label>
                            <div>{{ model.issue }}</div>
                        </div>
                    </div>
                </div>
            </template>
        </modal>

    </div>
</template>
<script>
import DateRangePicker from '../../components/DateRangePicker'
import moment from 'moment'

export default {
    components: {
        DateRangePicker
    },
    data() {
        return {
            showViewModal: false,
            isListLoading: false,
            service_tickets: [],
            procedures: [],
            problem_types: [],
            items: [],
            page: 1,
            last_page: 1,
            order_by: 'ticket_no',
            order: 'desc',
            filters: {
                search: '',
                product_type: 'all',
                product_model: 'all',
                item: 'all',
                problem_type: 'all',
                status: 'all',
                created_at: 'all'
            },
            created_at_label: 'Date Created: All',
            model: {}
        }
    },
    mounted() {
        let def_order = document.querySelector('#ses-list .list-head .col[data-key='+this.order_by+']')
        def_order.classList.add(this.order)
        def_order.dataset.order = (this.order == 'asc' ? 'desc' : 'asc')
        this.get_service_tickets()
        this.get_procedures()       
    },
    methods: {
        get_service_tickets() {
            this.isListLoading = true
            this.$http.get('/api/service_tickets?page=' + this.page 
                + '&order_by=' + this.order_by
                + '&order=' + this.order
                + '&filters=' + JSON.stringify(this.filters)
            )
                .then(response => {
                    if(this.page == 1) {
                        this.service_tickets = []
                    }
                    response.data.data.forEach(row => {
                        this.service_tickets.push(row)
                    })
                    this.last_page = response.data.last_page
                    this.isListLoading = false
                })
        },
        get_service_ticket(id) {
            this.showViewModal = true
            this.model = {}
            this.$http.get('/api/service_tickets/' + id)
                .then(response => {
                    this.model = response.data.data
                })
        },
        remove_service_ticket(id) {
            let conf = confirm('Are you sure you want to remove this ticket?')
            if(conf) {
                this.$http.put('/api/service_tickets/remove/' + id)
                    .then(() => {
                        this.get_service_tickets()
                        alert('Ticket removed!')
                    })
                    .catch(() => {
                        alert('Something went wrong!')
                    })
            }
        },
        get_procedures() {
            this.procedures = []
            this.$http.get('/api/st/procedures')
                .then(response => {
                    this.procedures = response.data.data
                })
        },
        get_items() {
            this.items = []
            let params = this.filters.product_type

            if(this.filters.product_type == 'Machines') {
                params = this.filters.product_type + '/' + this.filters.product_model
            }

            this.$http.get('/api/st/items/' + params)
                .then(response => {
                    this.items = response.data.data
                })
        },
        get_problem_types() {
            this.problem_types = []
            if(this.filters.product_model != 'Others') {
                this.problem_types = this.procedures[this.filters.product_type][this.filters.product_model]
            } else {
                let product_models = this.procedures[this.filters.product_type]
                for(let model in product_models) {
                    if(this.filters.item.indexOf(model) !== -1) {
                        this.problem_types = product_models[model]
                        break
                    }
                }
            }
        },
        scroll_list(e) {
            if(e.target.scrollTop + e.target.clientHeight >= (e.target.scrollHeight - 50) && !this.isListLoading) {
                this.page += 1
                if(this.page <= this.last_page) {
                    this.get_service_tickets()
                }
            }
        },
        sort_list(e) {
            if(!this.isListLoading) {
                Array.from(document.querySelectorAll('#ses-list .list-head .col')).forEach((el) => {
                    el.classList.remove('asc', 'desc')
                })
                let element = document.querySelector('#ses-list .list-head .col[data-key='+e.target.dataset.key+']')
                this.order_by = e.target.dataset.key
                this.order = element.dataset.order || 'asc'
                element.classList.add(this.order)
                element.dataset.order = (this.order == 'asc' ? 'desc' : 'asc')
                this.page = 1
                this.service_tickets = []
                this.get_service_tickets()
            }
        },
        filter_list() {
            this.page = 1
            this.service_tickets = []
            this.get_service_tickets()
        },
        reset_filter() {
            this.filters = {
                search: '',
                product_type: 'all',
                product_model: 'all',
                item: 'all',
                problem_type: 'all',
                status: 'all',
                created_at: 'all'
            }
            this.created_at_label = 'Date Created: All'
            this.page = 1
            this.service_tickets = []
            this.get_service_tickets()
            this.items = []
        },
        getRange(range) {
            this.filters.created_at = moment(range.startDate).format('YYYY/MM/DD') + ' - ' + moment(range.endDate).format('YYYY/MM/DD')
            this.created_at_label = this.filters.created_at
            this.filter_list()
        },
        clearRange() {
            this.filters.created_at = 'all'
            this.created_at_label = 'Date Created: All'
            this.filter_list()
        }
    }
}
</script>
<style lang="scss" scoped>
#ses-list {
    min-width: 700px;
    padding-right: 12px;
    .list-head .col {
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url('/api/public/img/bg.png');
        background-position: center right;
        background-repeat: no-repeat;
        cursor: pointer;
        white-space: normal;
        &.asc {
            background-image: url('/api/public/img/trans-asc.png');
        }
        &.desc {
            background-image: url('/api/public/img/trans-desc.png');
        }
        &.sort-false {
            background-image: none;
            cursor: default;
        }
    }
}
.progress {
    border-radius: 0;
}
.no-results-msg {
    text-align: center;
    padding: 0.5em;
    font-size: 11px;
}
.row-detail {
    display: flex;
    word-break: break-all;
    padding: 0.2em;
    label {
        min-width: 122px;
        font-weight: bold;
        margin: 0;
        margin-right: 0.5em;
    }
}
.modal::v-deep {
    .modal-dialog {
        max-width: 768px;
    }
}
.list-proj .row .badge-dot { margin: 0 0 0 6px !important; line-height: 16px; }
.list-proj .row .action { display: inline-block; padding: 7px; border: 0; letter-spacing: 0.3px; color: #fff; text-decoration: none; min-width: 86px; cursor: pointer; color: #fff; background-color: #5cb85c; margin-left: 6px; vertical-align: middle; }
.list-proj .row .action span { display: inline-block; background: #459e45; padding: 2px 7px; width: 29px; margin: -7px 2px -7px -8px; font-size: 17px; line-height: 26px; text-align: center; }
.badge {
    cursor: text;
    pointer-events: none;
    border-radius: 0;
    min-width: 84px;
    padding: 7px;
    border: 0;
    letter-spacing: .3px;
    color: #fff;
    text-decoration: none;
}
.badge-unapproved {
    background-color: #055091;
}
.badge-open {
    background-color: #459e45;
}
.badge-pending {
    background-color: gold;
}
.badge-closed {
    background-color: #c90000;
}
@media (min-width: 1200px) {
    .ses-content .filter-wrapper .filter-item {
        width: 19.6% !important;
    }
    .ses-content .filter-wrapper .search-filter {
        width: 29.6% !important;
    }
}
@media (max-width: 768px) {
    #ses-list {
        min-width: 1200px;
    }
}
</style>
